
    

    var instance = null;

    var icons = { 
        GAGUE: 'fal fa-gauge-high fa-fw',
        TABLE: 'fal fa-table fa-fw',
        LINE_CHART: 'fal fa-chart-line-up fa-fw',
        EXCLAMATION: 'fal fa-exclamation-triangle fa-fw',
        EXCLAMATION2: 'fal fa-sensor-triangle-exclamation fa-fw',
        BAR_CHART: 'fal fa-bar-chart fa-fw',
        USERS: 'fal fa-users fa-fw',
        USER: 'fal fa-id-card fa-fw',
        DESKTOP: 'fal fa-desktop fa-fw',
        BUILDING: 'fal fa-map-marker fa-fw',
        SHARE: 'fal fa-sign-in fa-fw',
        LABS: 'fal fa-flask fa-fw',
        COG: 'fal fa-cog fa-fw',
        PHONE_VOLUME: 'fal fa-volume-control-phone fa-fw',
        TELEVISION: 'fal fa-television fa-fw',
        SPEECH_BUBBLES: 'fal fa-comments-o fa-fw',
        SERVERS: 'fal fa-server fa-fw'
    };

    function MenuIcons() {
        if (instance !== null) {
            throw new Error('Cannot instanciate more than one MenuIcons. Use MenuIcons.getInstance().');
        }
    }

    MenuIcons.prototype = {
        getDashboard: function() { return icons.GAGUE; },
        getDatasets: function() {return icons.TABLE; },
        getAdoption: function() { return icons.LINE_CHART; },
        getIssues: function() { return icons.EXCLAMATION; },
        getCapacity: function() { return icons.BAR_CHART; },
        getMeetings: function() { return icons.USERS; },
        getEndpoints: function() { return icons.DESKTOP; },
        getRooms: function() { return icons.BUILDING; },
        getReports: function() { return icons.SHARE; },
        getLabs: function() { return icons.LABS; },
        getSettings: function() { return icons.COG; },
        getUsers: function() { return icons.USERS; },
        getUser: function() { return icons.USER; },
        getActiveCalls: function() { return icons.PHONE_VOLUME; },
        getActiveVMR: function() { return icons.TELEVISION; },
        getAlerts: function() { return icons.EXCLAMATION; },
        getMoi: function() { return icons.EXCLAMATION2; },
        getHosts: function() { return icons.USERS; },
        getScheduledMeetings: function() { return icons.USERS; },
        getSummaryViews: function() { return icons.LINE_CHART; },
        getIMSessions: function() { return icons.SPEECH_BUBBLES; },
        getInfrastructure: function() { return icons.SERVERS; }
    };

    MenuIcons.getInstance = function() {
        if (instance === null) {
            instance = new MenuIcons();
        }
        return instance;
    };

    export default MenuIcons.getInstance();
